// Generated by scripts/build-ui-icons.mjs.
export { PenNib as default } from "../ui/glyphs-6";
